import React, {Component} from 'react';

import {HashRouter, Route, Switch} from 'react-router-dom'

//import createBrowserHistory from 'history/createBrowserHistory'
import AppHeader from "./AppHeader";
import Deltakerliste from "./pages/deltakerliste/Deltakerliste";
import Kritikk from "./pages/kritikk/Kritikk";
import Sync from "./pages/sync/Sync";
import Insert from "./pages/insert/Insert"

import {ResultService} from "./services/resultService";
import {PersistService} from "./services/persistService";

import Log from "./pages/log/Log";
import System from "./pages/system/System";


//const history = createBrowserHistory();

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            partiLoaded : false,
            proeveId : null,
            klasseNavn : null
        }

        this.checkOutParti = this.checkOutParti.bind(this);
        this.checkInParti = this.checkInParti.bind(this);
        this.cancelParti = this.cancelParti.bind(this);
        this.loadPartiFromLocalStorage = this.loadPartiFromLocalStorage.bind(this);
        this.handleStorageEvent = this.handleStorageEvent.bind(this);
        this.handleOfflineEvent = this.handleOfflineEvent.bind(this);
        this.handleOnlineEvent = this.handleOnlineEvent.bind(this);

    }

    componentDidMount() {
        if (!this.state.partiLoaded) {
            this.loadPartiFromLocalStorage();
        }
        window.addEventListener('storage', this.handleStorageEvent, true);
        window.addEventListener('offline', this.handleOfflineEvent);
        window.addEventListener('online', this.handleOfflineEvent);
    }

    componentWillMount() {

    }


    componentWillUnmount() {
        window.removeEventListener('storage', this.handleStorageEvent);
        window.removeEventListener('offline', this.handleOfflineEvent);
        window.removeEventListener('online', this.handleOfflineEvent);
    }




    checkOutParti() {

        this.setState(() => ({
            partiLoaded : true,
            proeveId : ResultService.getProeveId(),
            klasseNavn: ResultService.getKlasse().klasseNavn
        }));
        //history.push('/');
        window.location.hash = "/";
    }

    checkInParti() {
        this.setState(() => ({
            partiLoaded : false,
            proeveId : null,
            klasseNavn: null
        }));
        //history.push('/sync');
        window.location.hash = "/sync";
    }

    cancelParti() {

        this.setState(() => ({
            partiLoaded : false,
            proeveId : null,
            klasseNavn: null
        }));
        window.location.hash = "/sync";
        //history.push('/sync');
    }

    loadPartiFromLocalStorage() {
        if (ResultService.isPartiInLocalStorage()) {

            this.setState(() => ({
                partiLoaded : true,
                proeveId : ResultService.getProeveId(),
                klasseNavn: ResultService.getKlasse().klasseNavn,
            }));

        }
    }



    handleStorageEvent(e) {
        if (e.key === 'dkk-proeve-lydighet-parti-'+ process.env.REACT_APP_ENV + '-id'
            && e.newValue.lastIndexOf(PersistService.getId(),0) === -1) {
            if (PersistService.getReloadTimer() != null) {
                clearTimeout(PersistService.getReloadTimer());
            }
            var timer = setTimeout(function() {
                ResultService.reloadFromLocalStorage();
                if (ResultService.getParti() == null) {
                    //history.push('/');
                    window.location.hash = "/";
                }
                window.location.reload();
                PersistService.setReloadTimer(null);
            }, 500);
            PersistService.setReloadTimer(timer);
        }
    }

    handleOnlineEvent(e) {
        console.log("Online event");
    }

    handleOfflineEvent(e) {
        console.log("Offline event");
    }

    render() {
        const {partiLoaded, klasseNavn, proeveId} = this.state;
        return (
            <HashRouter>
                <div>
                    <AppHeader />

                    <Switch>
                        <Route exact path="/" render={()=><Deltakerliste partiLoaded={partiLoaded} />  } />
                        <Route path="/sync" render={()=><Sync checkInParti={this.checkInParti} checkOutParti={this.checkOutParti} cancelParti={this.cancelParti} partiLoaded={partiLoaded} proeveId={proeveId} klasseNavn={klasseNavn} />} />
                        <Route path="/kritik/:id" render={(props)=> <Kritikk partiLoaded={partiLoaded} {...props} />}/>
                        <Route path="/log"><Log/></Route>
                        <Route path="/system"><System/></Route>
                        <Route path="/insert"><Insert/></Route>

                    </Switch>

                </div>
            </HashRouter>
        );
    }
}





export default App


// WEBPACK FOOTER //
// ./src/App.js